import React from "react";
import { Flex, IconButton, Tooltip } from "@bdo/cornerstone-ui";
import { RiFeedbackLine } from "@remixicon/react";
import { useAppDispatch } from "@/hooks";
import { openFeedback } from "@/features/overlays/feedbackSlice";

interface HeadingProps {
  children: React.ReactNode;
  rightContent?: React.ReactNode;
  hideFeedbackButton?: boolean;
}

export function Heading({
  children,
  rightContent,
  hideFeedbackButton = false,
}: Readonly<HeadingProps>) {
  const dispatch = useAppDispatch();

  return (
    <Flex
      justify="between"
      gap="lg"
      align="center"
      className="p-md border-b border-mono-lighter h-fit bg-white"
    >
      {children}

      {rightContent ? (
        <div>{rightContent}</div>
      ) : (
        !hideFeedbackButton && (
          <div>
            <Tooltip title="Share feedback" placement="bottom" delay={200}>
              <IconButton
                icon={<RiFeedbackLine />}
                aria-label="Open feedback panel"
                onClick={() => dispatch(openFeedback())}
                size="md"
                data-testid="feedback-button"
              />
            </Tooltip>
          </div>
        )
      )}
    </Flex>
  );
}
